import React, { useEffect, useState } from 'react';
import { Snackbar, Button } from '@material-ui/core';

const UpdateNotification = () => {
    const [showReload, setShowReload] = useState(false);

    useEffect(() => {
        const onSWUpdate = (e) => {
            const registration = e.detail;
            if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
            // Show reload notification as fallback
            setShowReload(true);
        };

        const onControllerChange = () => {
            // New SW has taken control — reload to get updated assets
            window.location.reload();
        };

        window.addEventListener('swUpdate', onSWUpdate);

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
        }

        // Also check on visibility change (when user returns to tab)
        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible' && 'serviceWorker' in navigator) {
                navigator.serviceWorker.ready.then((registration) => {
                    registration.update().catch(() => {});
                });
            }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);

        return () => {
            window.removeEventListener('swUpdate', onSWUpdate);
            document.removeEventListener('visibilitychange', onVisibilityChange);
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
            }
        };
    }, []);

    const handleReload = () => {
        setShowReload(false);
        window.location.reload();
    };

    return (
        <Snackbar
            open={showReload}
            message="Nova versão disponível!"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            action={
                <Button color="inherit" size="small" onClick={handleReload} style={{ fontWeight: 'bold' }}>
                    ATUALIZAR
                </Button>
            }
        />
    );
};

export default UpdateNotification;
